<template>
  <main class="main-wrapper flex-grow-1">
    <div class="d-flex align-items-center bg-white">
      <div
        class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
        {{ this.$t("1286") }}
      </div>
    </div>
    <div class="divider"></div>
    <!-- subtabs -->
    <div v-if="campaignData &&
      campaignData.dynamicLink &&
      campaignData.locationValue === null
      ">
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>
    <NoData v-if="isNoData"></NoData>
    <div v-else>
      <div class="container container--narrow pdb-50">
        <div class="mdc-card mgt-30 pdt-8 pdb-8">
          <div v-for="(questionList, index) in listData" :key="index" class="reportIssueList">
            <ListItem :questionList="questionList"></ListItem>
            <div class="divider" v-if="index + 1 < listData.length"></div>
          </div>
          <infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
            <div slot="no-more" class="mgt-16"></div>
            <div slot="no-results" class="mgt-16"></div>
          </infinite-loading>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import examApi from "@/api/examApi.js";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoDataReportIssue.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ListItem,
    NoData,
    InfiniteLoading,
  },

  data() {
    return {
      status: "",
      isNoData: false,
      isNoData1: true,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      mine: "",
      myStatus: "",
      infiniteId: +new Date(),
      resultData: null,
      memberId: 0,
    };
  },

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      memberApi
        .getMemberInfo()
        .then((response) => {
          this.memberId = response.data.data;

          let responseData = null;
          let params = this.setParams();

          if (this.totalPages >= this.currentPage) {
            examApi
              .eaxmIssueList(params)
              .then((response) => {
                responseData = response.data.data;

                responseData.content.forEach((sourceElement) => {
                  if (sourceElement.requesterId === this.memberId.id) {
                    this.listData = this.listData.concat(sourceElement);
                  }
                });

                this.currentPage++;
                this.totalPages = responseData.totalPages;
                if (responseData.content.length) {
                  $state.loaded();
                } else {
                  $state.complete();
                }

                if (this.listData.length > 0) {
                  this.isNoData = false;
                } else {
                  this.isNoData = true;
                }
              })
              .catch((err) => {
                $state.error();
              });
          } else {
            $state.complete();
          }
        })
        .catch((err) => { });
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        page: this.currentPage,
        size: 10,
        sort: "id,desc",
      };
      return params;
    },
  },
};
</script>

<style scoped>
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
  border-radius: 4px;

  box-shadow: 0 1px 3px 0 var(--Shadow1);
  background-color: var(--DocumentWhite);
}

.tabs .tab {
  width: 50%;
}

.reportIssueList:not(:last-child) .listItems {
  border-bottom: 1px solid var(--Divider);
}

.font-13 {
  font-size: 13px !important;
}
</style>